import { render, staticRenderFns } from "./DataEdit.vue?vue&type=template&id=93726c5a&"
import script from "./DataEdit.vue?vue&type=script&lang=js&"
export * from "./DataEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataEdit.vue?vue&type=style&index=0&id=93726c5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports